<template>
    <div class="form-item">
        <div class="form-item__label">
            附加需求
            <span class="form-item__intro">（地段/房屋楼层/装修/停车位等）</span>
        </div>
        <div class="form-item__body">
            <textarea v-model="info.content"
            placeholder="补充附加需求"
            class="form-item__body_input"
            maxlength="500"
            style="height: 150px;overflow-y: auto;"/>
        </div>
        <div class="demand-tags">
            <div class="demand-tags__item"
            v-for="(item, index) in tags"
            :key="index" @click="add(item)">
                + {{item}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['info'],
        data () {
            return {
                tags: [
                    '电梯房',
                    '带客厅',
                    '停车位',
                    '养宠物',
                    '通燃气',
                    '近地铁'
                ]
            }
        },
        methods: {
            add (tag) {
                this.info.content = this.info.content + (this.info.content ? '，' : '') + tag
            }
        }
    }
</script>

<style lang="less" scoped>
    .demand-tags {
        overflow: hidden;
        margin-top: 10px;
        margin-bottom: 20px;
        .demand-tags__item {
            float: left;
            font-size: 10pt;
            padding: 4px 10px;
            background-color: #f7f8f7;
            border-radius: 4px;
            margin-right: 5px;
            margin-bottom: 5px;
            color: #333;
        }
    }
</style>
